import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { SiteEditService } from '../../core/site-edit';
import { CacheModule } from '../cache';
import { CdnModule } from '../cdn';
import { OnlineStoreSetupModule } from '../online-store-setup/online-store-setup.module';
import { PublishTemplateModule } from '../publish-template';
import { GaOverviewMetricsComponent } from './ga-overview-metrics/ga-overview-metrics.component';
import { GaOverviewMetricsService } from './ga-overview-metrics/ga-overview-metrics.service';
import { Ga4OverviewMetricsComponent } from './ga4-overview-metrics/ga4-overview-metrics.component';
import { Ga4OverviewMetricsService } from './ga4-overview-metrics/ga4-overview-metrics.service';
import { ManageSiteComponent } from './manage-site/manage-site.component';
import { SiteHomeComponent } from './site/site.home.component';
import { SpeedScoreCardComponent } from './speed-score/speed-score-card.component';
import { SpeedScoreComponent } from './speed-score/speed-score.component';
import { SpeedScoreService } from './speed-score/speed-score.service';
import { TemplateHomeComponent } from './template/template.home.component';
import { VitalMetricsCardComponent } from './vital-metrics/vital-metrics-card.component';
import { VitalMetricsTableComponent } from './vital-metrics/vital-metrics-table.component';
import { VitalMetricsComponent } from './vital-metrics/vital-metrics.component';
import { VitalMetricsService } from './vital-metrics/vital-metrics.service';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { GalaxyFormFieldModule } from '@vendasta/galaxy/form-field';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { VaCardsModule } from '@vendasta/uikit';
import { FeatureFlagService } from '../../core/feature-flag.service';
import { AppDialogModule } from '../dialog';
import { LoadingStateCardModule } from '../loading-state-card/loading-state-card.module';
import { MetricsModule } from '../metrics/metrics.module';
import { RotateIconModule } from '../rotate-icon/rotate-icon.module';
import { PhpVersionStagingChangeComponent } from '../staging/cards/php-version-staging-change/php-version-staging-change.component';
import { PhpVersionChangeComponent } from './php-version-change/php-version-change.component';
import { UptimeReportComponent } from './uptime-report/uptime-report.component';
@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    TranslateModule,
    MatButtonModule,
    GalaxyAlertModule,
    PublishTemplateModule,
    CdnModule,
    CacheModule,
    OnlineStoreSetupModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatIconModule,
    AppDialogModule,
    MatDividerModule,
    MatTooltipModule,
    GalaxyAlertModule,
    NgxChartsModule,
    VaCardsModule,
    LoadingStateCardModule,
    RotateIconModule,
    MetricsModule,
    GalaxyPageModule,
    GalaxyFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    SiteHomeComponent,
    TemplateHomeComponent,
    SpeedScoreComponent,
    SpeedScoreCardComponent,
    VitalMetricsComponent,
    VitalMetricsCardComponent,
    VitalMetricsTableComponent,
    ManageSiteComponent,
    UptimeReportComponent,
    GaOverviewMetricsComponent,
    PhpVersionChangeComponent,
    Ga4OverviewMetricsComponent,
    PhpVersionStagingChangeComponent,
  ],
  exports: [SiteHomeComponent, TemplateHomeComponent],
  providers: [
    SiteEditService,
    SpeedScoreService,
    VitalMetricsService,
    GaOverviewMetricsService,
    FeatureFlagService,
    Ga4OverviewMetricsService,
  ],
})
export class HomeModule {}
